/*jshint esversion: 6 */

import $ from 'jquery';
import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

class NewsCarousel {

  constructor($main) {
    if (!this.initDomElements($main)) return false;

    this.domElements.items.on('beforeChange', () => {
      this.domElements.textWrap.fadeOut(120);
    });

    this.domElements.items.on('afterChange', () => {
      this.showCurrentContent();
    });

    this.domElements.items.slick({
      infinite: true,
      adaptiveHeight: false,
      autoplay: true,
      fade: false,
      pauseOnHover: false,
      dots: false,
      appendDots: this.domElements.contentInside,
      appendArrows: this.domElements.content,
      speed: 500,
      autoplaySpeed: 5000,
    });

    this.showCurrentContent();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;

    this.domElements.items = this.domElements.main.find('.news-carousel__items');
    this.domElements.content = this.domElements.main.find('.news-carousel__content');
    this.domElements.contentInside = this.domElements.main.find('.news-carousel__content__inside');
    this.domElements.textWrap = this.domElements.main.find('.news-carousel__content__text-wrap');

    return true;
  }

  showCurrentContent() {
    const $slide = this.domElements.items.find('.slick-current');
    const $content = $slide.find('.news-carousel-item__text-wrap');
    this.domElements.textWrap.html($content.html());
    this.domElements.textWrap.fadeIn();
  }

}

export default NewsCarousel;
